import defaultDayjs, { PluginFunc } from "dayjs"
import "dayjs/locale/ja"

const getJpYear = (date: Date): string => {
  let result: string
  try {
    result = Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
      year: "2-digit",
      era: "long",
    })
      .format(date)
      .slice(0, -1)
  } catch {
    result = "該当なし"
  }
  return result
}

const getJpEra = (date: Date): string => {
  let result: string
  try {
    result = Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
      era: "long",
    })
      .format(date)
      .slice(0, 2)
  } catch {
    result = "不明"
  }
  return result
}

const jpFormat: PluginFunc = function (_o, c) {
  const proto = c.prototype
  const oldFormat = proto.format

  proto.format = function (formatStr) {
    const result = formatStr.replace(/\[([^\]]+)]|r+|/g, (match) => {
      switch (match) {
        case "rrrr":
          return getJpYear(this.toDate())
        case "rr":
          return getJpEra(this.toDate())
        default:
          return match
      }
    })
    return oldFormat.bind(this)(result)
  }
}

export const dayjs = (
  date?: defaultDayjs.ConfigType,
  option?: defaultDayjs.OptionType,
  locale?: string
): defaultDayjs.Dayjs => {
  defaultDayjs.locale("ja")
  defaultDayjs.extend(jpFormat)
  return defaultDayjs(date, option, locale)
}
